import React from "react";
import CatalogMenu from "../../../content/json/components/catalog-menu.json";
import { NavLink } from "react-router-dom";
import $ from "jquery";
import { msalAuth } from "../../../api/msal/MsalAuthProvider";
import TreeChildren from "./TreeChildren";
import MyContext from "../../../api/context/my-context";
import SideMenuBottom from "./SideMenuBottom";
import * as Common from "../../common/common";
import * as omnimap from "../../../api/omnimap/omnimapActions";
class SideMenu extends React.Component {
  constructor(props) {
    super(props);
    this.handleEvent = this.handleEvent.bind(this);

    this.state = {
      tabName: props.tabName,
      menuName: props.menuName,
      token: null,
      treeList: [],
      treeCount: 0,
      treekey: props.treekey,
      pureTree: [],
      isLoading: true,
    };
  }
  handleEvent() {
    var tree = this.state.treeList;
    var pureTree = this.state.pureTree;
    this.state = {
      tabName: this.props.tabName,
      menuName: this.props.menuName,
      token: this.state.token,
      treeList: tree,
      treekey: this.props.treekey,
      pureTree: pureTree,
      isLoading: this.state.isLoading,
      // treeCount: this.state.treeCount,
    };
  }

  list = [];
  model = {
    content: [
      {
        key: "algemeen-isvoor",
        and_or: "AND",
        values: [this.props.treekey],
        datatype: "STRING",
      },
    ],
    context: [],
    timestamps: [],
    definitions: [process.env.REACT_APP_TREE],
    statuses: [],
  };

  async GetTreeStructure(model) {
    this.setState({ isLoading: true });
    var that = this;

    if (that.state.treekey === "financial") {
      let treeList = [
        {
          children: [],
          id: process.env.REACT_APP_CATALOG_BUDGET,
          isSubfolder: "false",
          name: "Budget",
          parentfolder: "undefined",
        },
        {
          children: [],
          id: process.env.REACT_APP_GROOTBOEK,
          isSubfolder: "false",
          name: "Grootboekrekening",
          parentfolder: "undefined",
        },
      ];
      that.setState({ treeList: treeList, treeCount: 2, isLoading: false });
      return "";
    } else if (that.state.treekey === "gebruikersbeheer") {
      let treeList = [
        {
          children: [],
          id: "gebruikersbeheer",
          isSubfolder: "false",
          name: "Gebruikersbeheer",
          parentfolder: "undefined",
        },
        {
          children: [],
          id: "organisatie",
          isSubfolder: "false",
          name: "Organisatie",
          parentfolder: "undefined",
        },
      ];
      that.setState({ treeList: treeList, treeCount: 2, isLoading: false });
      return "";
    }

    await Common.GetTreeStructurePure("", model, that.state.token).then(
      function (pureTreeList) {
        if (pureTreeList != undefined) {
          that.setState({ pureTree: pureTreeList });
        } else {
          that.setState({ pureTree: [] });
        }
      }
    );

    await Common.GetTreeStructure("", model, that.state.token).then(function (
      TreeResult
    ) {
      if (TreeResult != undefined) {
        that.setState({ treeList: [] });
        that.setState({
          treeList: TreeResult.treeList.sort(function (a, b) {
            if (a.name.toLowerCase() < b.name.toLowerCase()) {
              return -1;
            }
            if (a.name.toLowerCase() > b.name.toLowerCase()) {
              return 1;
            }
            return 0;
          }),
          isLoading: false,
        });
        window.$catalog_management_units_treeList = TreeResult.treeList;
        that.setState({ treeCount: TreeResult.treecount });
      } else {
        that.setState({ treeList: [], isLoading: false });
        that.setState({ treeCount: null });
      }
    });
  }

  async getTreeNatureProtection() {
    var soortListResult = [];
    var naamList = [];
    var periodList = [];
    var model = {
      context: [],
      sorting: [],
      definitions: [process.env.REACT_APP_CATALOG_NATURE_PROTECTION],
    };
    await omnimap.GetEntityListAction(model, 1, 10000).then(async (result) => {
      window.$nature_protection_treeListPure = result.data;
      var soortList = [
        ...new Set(result.data.map((item) => item.content["algemeen-soort"])),
      ];
      // foreach
      await soortList.forEach((soort) => {
        var filteredNaam = result.data.filter(
          (x) => x.content["algemeen-soort"] === soort
        );
        // foreach
        naamList = [];
        var filteredNaamUniqe = [
          ...new Set(
            filteredNaam.map((item) => item.content["algemeen-nederlandsenaam"])
          ),
        ];
        filteredNaamUniqe.forEach((nederlandsenaam) => {
          var filteredPeriod = result.data.filter(
            (x) =>
              x.content["algemeen-soort"] === soort &&
              x.content["algemeen-nederlandsenaam"] ===
                nederlandsenaam /*.content["algemeen-nederlandsenaam"]*/
          );
          var filteredPeriodUniqe = [
            ...new Set(
              filteredPeriod.map((item) => item.content["algemeen-naamperiode"])
            ),
          ];
          // foreach
          periodList = [];
          filteredPeriodUniqe.forEach((period) => {
            periodList.push({
              children: [],
              name: period /*.content["algemeen-naamperiode"]*/,
              id: period /*.identification*/,
              isSubfolder: true,
              type: "algemeen-naamperiode",
              parentfolder: nederlandsenaam /*.identification*/,
            });
          });
          naamList.push({
            children: periodList,
            name: nederlandsenaam /*.content["algemeen-nederlandsenaam"]*/,
            id: nederlandsenaam /*.identification*/,
            isSubfolder: true,
            parentfolder: soort,
            type: "algemeen-nederlandsenaam",
          });
        });
        soortListResult.push({
          children: naamList,
          name: soort,
          id: soort,
          isSubfolder: false,
          parentfolder: undefined,
          type: "algemeen-soort",
        });
      });
    });
    var test = soortListResult;
    this.setState({ treeList: [] });
    this.setState({
      treeList: soortListResult.sort(function (a, b) {
        if (a.name.toLowerCase() < b.name.toLowerCase()) {
          return -1;
        }
        if (a.name.toLowerCase() > b.name.toLowerCase()) {
          return 1;
        }
        return 0;
      }),
      isLoading: false,
    });
  }

  async getNatureProtectionTreeStructure() {
    this.setState({ isLoading: true });
    this.setState({ treeList: [] });
    var periodeList = [];
    var nederlandseNaamList = [];
    var soortList = [];

    var model = {
      definitions: ["7fefa5ee-cc8a-4c9a-bfdb-10fc49255fb3"],
      query: {
        content: [
          {
            values: [],
            key: "algemeen-soort",
            and_or: "AND",
            datatype: "STRING",
          },
          {
            values: [],
            key: "algemeen-wetenschappelijkenaam",
            and_or: "AND",
            datatype: "STRING",
          },
          {
            values: [],
            key: "algemeen-nederlandsenaam",
            and_or: "AND",
            datatype: "STRING",
          },
          {
            values: [],
            key: "algemeen-wet",
            and_or: "AND",
            datatype: "STRING",
          },
          {
            values: [],
            key: "algemeen-ovg",
            and_or: "AND",
            datatype: "STRING",
          },
          {
            values: [],
            key: "algemeen-naamperiode",
            and_or: "AND",
            datatype: "STRING",
          },
        ],
        definitions: ["7fefa5ee-cc8a-4c9a-bfdb-10fc49255fb3"],
        statuses: [],
        context: [],
      },
    };

    //soort
    model.query.content[0].key = "algemeen-soort";
    await omnimap
      .FillFilterColumnsAction(model, "algemeen-soort")
      .then(async (soortresult) => {
        var resultList = [];
        for (
          let soortIndex = 0;
          soortIndex < soortresult.data.values.length;
          soortIndex++
        ) {
          const soort = soortresult.data.values[soortIndex];
          resultList = [];
          model.query.content[0].key = "algemeen-soort";
          model.query.content[0].values = [];
          model.query.content[0].values.push(soort);
          await omnimap
            .FillFilterColumnsAction(model, "algemeen-nederlandsenaam")
            .then(async (naamresult) => {
              //naam
              model.query.content[0].values = [];
              model.query.content[0].values.push(soort);
              for (
                let nederlandsIndex = 0;
                nederlandsIndex < naamresult.data.values.length;
                nederlandsIndex++
              ) {
                const nederlandsenaam = naamresult.data.values[nederlandsIndex];
                periodeList = [];
                //periode
                model.query.content[0].key = "algemeen-nederlandsenaam";
                model.query.content[0].values = [];
                model.query.content[0].values.push(nederlandsenaam);
                await omnimap
                  .FillFilterColumnsAction(model, "algemeen-naamperiode")
                  .then((result) => {
                    result.data.values.forEach((item) => {
                      periodeList.push({
                        children: [],
                        name: item,
                        id: item,
                        isSubfolder: true,
                        parentfolder: nederlandsenaam,
                        type: "naamperiode",
                      });
                    });
                  });
                resultList.push({
                  children: periodeList,
                  name: nederlandsenaam,
                  id: nederlandsenaam,
                  isSubfolder: true,
                  parentfolder: soort,
                  type: "nederlandsenaam",
                });
              }
            });
          soortList.push({
            children: resultList,
            name: soort,
            id: soort,
            isSubfolder: false,
            parentfolder: soort,
            type: "soort",
          });
        }

        // result.data.values.forEach(async (item) => {

        //   soortList.push({
        //     children: resultList,
        //     name: item,
        //     id: 0,
        //     isSubfolder: false,
        //     parentfolder: 0,
        //   });
        // });
      });

    this.setState({ treeList: [] });
    this.setState({
      treeList: soortList.sort(function (a, b) {
        if (a.name.toLowerCase() < b.name.toLowerCase()) {
          return -1;
        }
        if (a.name.toLowerCase() > b.name.toLowerCase()) {
          return 1;
        }
        return 0;
      }),
      isLoading: false,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    var that = this;
    if (prevProps.treekey != that.state.treekey) {
      var model = {
        content: [
          {
            key: "algemeen-isvoor",
            and_or: "AND",
            values: [that.state.treekey],
            datatype: "STRING",
          },
        ],
        definitions: [process.env.REACT_APP_TREE],
      };

      if (that.state.treekey === "nature-protection") {
        // that.getNatureProtectionTreeStructure();
        that.getTreeNatureProtection();
      } else {
        that.GetTreeStructure(model);
      }

      $("#side-menu-treeButton").click();
    }
  }

  async componentDidMount() {
    var that = this;
    try {
      const accessTokenRequest = {
        scopes: ["user.read", "openid", "profile"],
      };
      var accessToken = null;
      try {
        accessToken = await msalAuth
          .acquireTokenSilent(accessTokenRequest)
          .then((response) => {
            // token = response.idToken.rawIdToken;
            that.setState({ token: response.idToken.rawIdToken });
          });
      } catch (error) {
        console.log("AquireTokenSilent failure");
        console.log(error);
        accessToken = await msalAuth
          .acquireTokenPopup(accessTokenRequest)
          .then((response) => {
            // get access token from response
            // response.accessToken
            // token = response.idToken.rawIdToken;
            that.setState({ token: response.idToken.rawIdToken });
          })
          .catch((err) => {
            // handle error
            console.log(err);
          });
      }
    } catch (err) {
      var error = {};
      if (typeof err === "string") {
        var errParts = err.split("|");
        error =
          errParts.length > 1
            ? { message: errParts[1], debug: errParts[0] }
            : { message: err };
      } else {
        error = {
          message: err.message,
          debug: JSON.stringify(err),
        };
      }

      this.setState({
        user: {},
        isLoading: false,
        error: error,
        treeList: null,
      });
    }

    if (that.state.treekey === "nature-protection") {
      // that.getNatureProtectionTreeStructure();
      await that.getTreeNatureProtection();
    } else {
      await that.GetTreeStructure(that.model);
    }

    // await that.GetTreeStructure(that.model);
  }

  render() {
    this.handleEvent();
    if (this.state.menuName === "catalog") {
      var menuList = CatalogMenu.menus;
    }
    return (
      <div>
        <ul className="left-menu ul">
          {menuList.map((s) => (
            <div>
              {s.componentName === this.state.tabName ? (
                <li key={s.id.toString()}>
                  <NavLink
                    className="icon-filter-act"
                    to={{
                      pathname:
                        "/" + this.state.menuName + "/" + s.componentName,
                      componentName: s.componentName,
                      isDidUpdate: "0038",
                    }}
                  >
                    <span className={s.icon} />
                    {s.name}
                    <span
                      class={
                        s.isTree && this.state.isLoading
                          ? "spinner-border spinner-border-sm"
                          : ""
                      }
                      role="status"
                      aria-hidden="true"
                    ></span>
                  </NavLink>
                </li>
              ) : (
                <li key={s.id.toString()}>
                  <NavLink
                    className=""
                    to={{
                      pathname:
                        "/" + this.state.menuName + "/" + s.componentName,
                      componentName: s.componentName,
                      isDidUpdate: "0038",
                    }}
                  >
                    <span className={s.icon} />
                    {s.name}
                  </NavLink>
                </li>
              )}
              {s.isTree ? (
                this.state.treeList.length > 0 ? (
                  s.componentName === this.state.tabName ? (
                    <MyContext.Consumer>
                      {(context) => (
                        <div>
                          <TreeChildren
                            TreeList={
                              context.store.treeCount == null
                                ? this.state.treeList
                                : context.store.treeCount !=
                                  this.state.treeCount
                                ? context.store.treeList
                                : this.state.treeList
                            }
                            TreeCountUpdate={context.store.treeCount}
                            TreeCount={this.state.treeCount}
                            componentName={s.componentName}
                            pathname={this.state.menuName}
                            pureTree={this.state.pureTree}
                          />
                        </div>
                      )}
                    </MyContext.Consumer>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )
              ) : (
                ""
              )}
            </div>
          ))}
        </ul>

        <SideMenuBottom />
        <MyContext.Consumer>
          {(context) => (
            <div hidden>
              <button
                id="side-menu-treeButton"
                onClick={() => context.actions.addTask([])}
              >
                + add
              </button>
            </div>
          )}
        </MyContext.Consumer>
      </div>
    );
  }
}

export default SideMenu;
